import { Text, Box } from '@chakra-ui/react';
import { useState } from 'react';
import { useCreatePerson } from '@services/query-services/people.query-service';
import { useStyledToast } from '@util/hooks';
import UserForm from '@components/settings/user-form.component';
import { useUserStore } from '@store/app.store';
import { generateSecurePassword } from '@util/helpers/person.helpers';

export default function CreateUserPage() {
  const [isSubmitting, setIsSubmitting] = useState();
  const { mutateAsync: createPerson } = useCreatePerson();
  const toast = useStyledToast();
  const selectedTenant = useUserStore((state) => state.tenant);

  const onFinish = async (values) => {
    setIsSubmitting('submitting');
    values.password = generateSecurePassword();

    await createPerson(
      {
        ...values,
        tenants: [{ id: selectedTenant?.id }]
      },
      {
        onSuccess: () => {
          setIsSubmitting('success');
          toast({
            title: 'User successfully created',
            status: 'success',
            duration: 4000,
            isClosable: true
          });
          setTimeout(() => setIsSubmitting(''), 1000);
        },
        onError: (err) => {
          setIsSubmitting('error');
          const errorMsg = err?.response?.data?.errors?.[0];
          toast({
            title: `Failed to create user${errorMsg ? ', ' + errorMsg : '.'}`,
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }
      }
    );
  };

  return (
    <Box
      style={{ padding: 20 }}
      alignItems='flex-start'
    >
      <Text
        fontSize='lg'
        variant='page-header'
        pb={5}
      >
        Add User
      </Text>
      <UserForm
        onFinish={onFinish}
        style={{ maxWidth: 600 }}
        selectedTenantId={selectedTenant?.id}
        isSubmitting={isSubmitting}
      />
    </Box>
  );
}
